import { useEffect } from 'react';
import { mainButton, useLaunchParams } from '@telegram-apps/sdk-react';
import { useTranslation } from 'react-i18next';

import LottieAnimation from '@/animations/LottieAnimation.tsx';
import smartphone_animation from '@/components/common/svg/assets/smartphone.json';
import { helpers } from '@/helpers.ts';
import { TgLanguageCodes } from '@/constants/tg-language-codes.ts';

interface FallbackUIProps {
  buttonTextKey: string;
  messageTextKey: string;
  onButtonClick: () => void;
}

export function FallbackUI({
  buttonTextKey,
  messageTextKey,
  onButtonClick
}: FallbackUIProps) {
  const launchParams = useLaunchParams();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const lang = helpers.convertToI18nLanguageCode(
      (launchParams?.tgWebAppData?.user?.language_code as TgLanguageCodes) ??
        'uk'
    );

    void i18n.changeLanguage(lang);

    mainButton.setParams({
      isEnabled: true,
      isVisible: true,
      text: t(buttonTextKey)
    });

    mainButton.onClick(onButtonClick);

    return () => {
      mainButton.offClick(onButtonClick);
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          width: '70%',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px'
        }}
      >
        <LottieAnimation
          width={200}
          height={200}
          animationData={smartphone_animation}
          shouldAnimate={true}
          loop={false}
        />
        <div
          style={{
            color: 'black',
            fontWeight: 'bold',
            fontSize: '16px',
            textAlign: 'center'
          }}
        >
          {t(messageTextKey)}
        </div>
      </div>
    </div>
  );
}
